import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, defineMessages } from 'react-intl'

import Button from 'components/UI/Button/Button'
import SchoolStatusBanner from '../SchoolStatusBanner/SchoolStatusBanner'

import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import {
  Wrapper,
  Title,
  InfoSection,
  Paragraph,
  ImageTextWrapper,
  AmazonImage
} from './VoucherOffer.styles'
import { GradientWrapper } from '../../../../DashboardSettings.styles'

const messages = defineMessages({
  voucherTitle: {
    id: 'dashboard.referrals.voucherTitle',
    defaultMessage: 'Earn £100 in Amazon vouchers'
  },
  voucherSubTitle: {
    id: 'dashboard.referrals.voucherSubTitle',
    defaultMessage: 'Reach 6 subscribing teachers in your school'
  },
  voucherText: {
    id: 'dashboard.referrals.voucherText',
    defaultMessage: 'To take advantage of this offer, you must become the Night Zookeeper ambassador for your school.'
  },
  applyNow: {
    id: 'dashboard.referrals.applyNow',
    defaultMessage: 'Apply now'
  },
  ambassadorThanks: {
    id: 'dashboard.referrals.ambassadorThanks',
    defaultMessage: 'Thanks for your interest in becoming a Night Zookeeper ambassador! A member of our team will be in touch with you soon.'
  }
})

export default class VoucherOffer extends Component {
  static propTypes = {
    teachers: PropTypes.array,
    ambassador: PropTypes.bool
  }

  // static defaultProps = {
  //   ambassador: false
  // }

  render () {
    const { teachers, direction, ambassador, sendAmbassadorEmail, ambassadorEmailSent } = this.props

    const ambassadorStatus = ambassadorEmailSent || ambassador
      ? <Paragraph color='yellow'>
        <FormattedMessage {...messages.ambassadorThanks} />
      </Paragraph>
      : <Fragment>
        <Paragraph color='pink'>
          <FormattedMessage {...messages.voucherText} />
        </Paragraph>
        <Button bgColor={colors.blue} color={colors.white} size='regular' width='50%' type='submit' onClick={sendAmbassadorEmail}>
          <FormattedMessage {...messages.applyNow} />
        </Button>
      </Fragment>

    return (
      <GradientWrapper direction={direction}>
        <Wrapper>
          <Title type='main'>
            <FormattedMessage {...messages.voucherTitle} />
          </Title>
          <ImageTextWrapper>
            <AmazonImage />
            <InfoSection>
              <Title type='sub'>
                <FormattedMessage {...messages.voucherSubTitle} />
              </Title>
              {ambassadorStatus}
            </InfoSection>
          </ImageTextWrapper>
          <SchoolStatusBanner teachers={teachers} />
        </Wrapper>
      </GradientWrapper>
    )
  }
}
